import enviro from 'enviro';
import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
export const CurrentOwnerContext = /*#__PURE__*/createContext(-1);
CurrentOwnerContext.Provider.propTypes = {
  value: PropTypes.number.isRequired
};
export function useCurrentOwnerContext() {
  const currentOwnerId = useContext(CurrentOwnerContext);
  // we explicitly should check for null/undefined here in case a user
  // somehow has an ownerId of 0
  if (currentOwnerId == null && enviro.isQa() && !enviro.deployed()) {
    console.error('[useCurrentOwnerContext]: Owner ID not defined, context may not be configured properly');
  }
  return currentOwnerId == null ? -1 : currentOwnerId;
}